import { fetchData } from '../utils/netUtils';
import {
  removeEmptyKeys
} from '../utils/objectUtils';
import {
  resolveCurrentEnvironment
} from '../utils/configUtils';

const getLoginURL = (client, idp, countryCode, redirectURI, d2cidp, cancelURL, errorURL) => {
  const currentENV = resolveCurrentEnvironment();
  const baseURL =`${currentENV.TBX_CLOUDPASS_API}/auth/authorize`;
  const paramsData = removeEmptyKeys({
    'cancel': cancelURL,
    'client_id': client,
    'country': countryCode,
    'd2cidp': d2cidp,
    'errorurl': errorURL,
    'idp': idp,
    'redirect_uri': redirectURI,
    'response_type': 'code'
  });
  const queryParams = Object.keys(paramsData).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(paramsData[key])).join('&');

  return baseURL + `?${queryParams}`;
}

const getLogoutURL = (client, returnURL) => {
  const currentENV = resolveCurrentEnvironment();
  const logoutURL = `${currentENV.TBX_CLOUDPASS_API}/auth/${client}/logout.json?url=${encodeURIComponent(returnURL)}`;

  return logoutURL;
};

const getIdpsOfContentProvider = (client)  => {
  const currentENV = resolveCurrentEnvironment();
  const URL = `${currentENV.TBX_CLOUDPASS_API}/auth/${client}/mso.json`;

  const options = {
    credentials: 'omit',
    method: 'GET',
    headers: {
    }
  };

  return fetchData(URL, options);
}

const cpassAuthService = {
  callLogoutRedirect: async (returnURL) => {
    const logoutURL = getLogoutURL(returnURL);
    const options = {
      credentials: 'omit',
      method: 'GET',
      headers: {
      },
      redirect: 'manual'
    };

    return fetchData(logoutURL, options);
  },

  getDeviceOauth2Token: ({
    clientID,
    code,
    grantType = 'authorization_code',
    redirectURI
  }) => {
    const currentENV = resolveCurrentEnvironment();
    const URL = `${currentENV.TBX_CLOUDPASS_API}/auth/token`;
    const paramsData = {
      'client_id': clientID,
      'code': code,
      'grant_type': grantType,
      'redirect_uri': redirectURI
    };
    const formBody = Object.keys(paramsData).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(paramsData[key])).join('&');
    const options = {
      credentials: 'omit',
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: formBody
    };

    return fetchData(URL, options);
  },

  getLoginURL,
  getLogoutURL,
  getIdpsOfContentProvider
};

export default cpassAuthService;
